import React from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import "../../CVs/CvDetails/CvDetails.css";
import Grid from "@material-ui/core/Grid";
import Icon from "../Icon/Icon";
import {translation} from "../../../I18n/i18n";


const ConsultCard = (props) => {

    return (
        <Card key={props.index}>
            <Grid container className="cardTitle">
                <Grid item xs={11}>
                    <CardHeader titleTypographyProps={{variant: 'subtitle1'}} title={props.title}
                                subheaderTypographyProps={{variant: 'subtitle1'}}/>
                </Grid>
                {props.hasWriteAccess && <Grid item xs={1}>
                    <Icon classIcon="fas fa-pencil-alt" color="#464775" size="15px" margin="10px"
                          label={translation(props.lang, "Edit")} action={props.editElement}/>
                    <Icon classIcon="fas fa-trash-alt" color="#464775" size="15px" margin="10px"
                          label={translation(props.lang, "Delete")} action={props.removeElement}/>
                </Grid>
                }
            </Grid>

        </Card>
    );
};

export default ConsultCard;
